export default __webpack_public_path__ + "static/media/main-app-white.3f53f935.png";